import { getOpDef } from './transform-vocab.js';
/**
 * Translate a mapping-row chain step into a Post-OCR Behavior.
 *
 * Same vocabulary, different property names:
 *   ChainStep:   { type, config }
 *   Behavior:    { kind: 'transform', op, params }
 */
export function chainStepToBehavior(step) {
    return {
        kind: 'transform',
        op: step.type,
        params: step.config,
    };
}
/**
 * Find all chain steps whose op belongs to the cross-field family.
 *
 * Detection uses the registry's `family` field rather than a hardcoded id list,
 * so any future cross-field op is flagged automatically.
 *
 * Plugin ops (not in the built-in registry) are NOT flagged — static cross-field
 * detection inside a plugin's DSL is filed as
 * `52-followup-promote-plugin-cross-field-validation`.
 */
export function findCrossFieldOps(steps) {
    const offenders = [];
    for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        const def = getOpDef(step.type);
        if (def?.family !== 'cross-field')
            continue;
        const cfg = step.config;
        const referencedFieldName = typeof cfg?.fieldName === 'string' ? cfg.fieldName : undefined;
        offenders.push({
            stepIndex: i,
            opId: step.type,
            opLabel: def.label,
            referencedFieldName,
        });
    }
    return offenders;
}
//# sourceMappingURL=promote-to-canonical.js.map